import {Injectable} from '@angular/core';

@Injectable()
export class UtilService {

  constructor() {
  }

  objectToHash(obj: Object): number {
    return this.createHash(JSON.stringify(this.sortObjectKeys(obj)));
  }

  createHash(str: string): number {
    let hash = 0, chr;

    if (str.length === 0) {
      return hash;
    }
    for (let i = 0; i < str.length; i++) {
      chr = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }

  sortObjectKeys(obj: Object): Object {
    // Deep copy since it has object inside an object
    const copyObj = JSON.parse(JSON.stringify(obj));
    const ordered = {};
    Object.keys(copyObj).sort().forEach((key: string) => {
      ordered[key] = copyObj[key];
    });

    return ordered;
  }

  deepEquals(x: Object, y: Object): boolean {
    if (x === y) {
      return true; // if both x and y are null or undefined and exactly the same
    } else if (!(x instanceof Object) || !(y instanceof Object)) {
      return false; // if they are not strictly equal, they both need to be Objects
    } else if (x.constructor !== y.constructor) {
      // they must have the exact same prototype chain, the closest we can do is
      // test their constructor.
      return false;
    } else {
      for (const p in x) {
        if (!x.hasOwnProperty(p)) {
          continue; // other properties were tested using x.constructor === y.constructor
        }
        if (!y.hasOwnProperty(p)) {
          return false; // allows to compare x[ p ] and y[ p ] when set to undefined
        }
        if (x[p] === y[p]) {
          continue; // if they have the same strict value or identity then they are equal
        }
        if (typeof (x[p]) !== 'object') {
          return false; // Numbers, Strings, Functions, Booleans must be strictly equal
        }
        if (!this.deepEquals(x[p], y[p])) {
          return false;
        }
      }
      for (const p in y) {
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
          return false;
        }
      }
      return true;
    }
  }

  compareSortedArray(a1: any[], a2: any[]): boolean {
    return a1.length === a2.length && a1.every((v, i) => v === a2[i]);
  }

  fahrenheitToCelsius(fahrenheit: number): number {
    return (fahrenheit - 32) * 5 / 9;
  }

  celsiusToFahrenheit(celsius: number): number {
    return celsius * 9 / 5 + 32;
  }
}
